import { html } from 'lit';
import '@crossiety/lit-components/components/progress_bar/element.js';
import CardOption from '../card_option/element.js';
import style from './style.lit.css';

/**
 * Represents one option in a poll card
 *
 * @prop totalEngagedUsersCount - Total number of votes for this card, used to calculate percent.
 *
 * @cssprop [--progress-bar-height: 6px] Height of progress bar
 * @cssprop [--progress-bar-margin: 8px 0 8px 0] Margin of progress bar
 * @cssprop [--progress-bar-color: var(--primary)] Color of progress bar
 * @cssprop [--progress-bar-color-disabled: var(--gray-300)] Color of progress bar when option is disabled
 * @cssprop [--progress-bar-box-shadow: none] Box shadow of progress bar (empty part).
 * @cssprop [--progress-bar-value-border-radius: 0] Border radius of progress bar value.
 * @cssprop [--progress-bar-value-box-shadow: none] Box shadow of progress bar (full part).
 *
 * @slot default - Title/label
 * @slot avatars - Avatar list of helpers
 */

export default class PollOption extends CardOption {
  static styles = [CardOption.styles, style];

  static properties = {
    totalEngagedUsersCount: { type: Number },
  };

  static config = {
    icons: {
      check: '',
      minus: 'check:solid',
      plus: '',
    },
  };

  /** @internal */
  get percent() {
    if (!this.totalEngagedUsersCount) return 0;

    return Math.round(
      (this.engagedUsersCount * 100) / this.totalEngagedUsersCount
    );
  }

  /** @internal */
  get checkUrl() {
    return `/cards/${this.cardId}/poll_options/${this.itemId}/vote`;
  }

  /** @internal */
  get detailsUrl() {
    return `/poll_cards/${this.cardId}/votes?option=${this.itemId}`;
  }

  uncheckAction() {
    this.commonActions.post(this.checkUrl);
  }

  renderLabel() {
    return html`<ef-label>${Math.round(this.percent)}%</ef-label>`;
  }

  renderProgressBar() {
    return html`<ef-progress-bar .percent=${this.percent}></ef-progress-bar>`;
  }

  renderColumnLayout() {
    return html`
      <div class="top">
        <div class="left">
          ${this.renderTitle()}
          ${this.resultsHidden ? null : this.renderLabel()}
        </div>
        <div class="right">
          ${this.renderAvatars()} ${this.renderActionWrapper()}
        </div>
      </div>
      ${this.resultsHidden ? null : this.renderProgressBar()}
    `;
  }

  renderRowLayout() {
    return html`
      <div class="top">${this.renderTitle()}</div>
      <div class="bottom">
        <div class="left">
          ${this.resultsHidden ? null : this.renderLabel()}
          ${this.renderAvatars()}
        </div>
        <div class="right">${this.renderActionWrapper()}</div>
      </div>
      ${this.resultsHidden ? null : this.renderProgressBar()}
    `;
  }
}

customElements.get('xs-poll-option') ||
  customElements.define('xs-poll-option', PollOption);
